import { useState } from "react";
import chevronDown from "./imgs/chevron-down.svg";
import chevronUp from "./imgs/chevron-up.svg";

const FaqItem = ({ category, questions, isLast, onTrackButtonClick }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="faq-container">
      <div className={`faq-item ${isLast ? "faq-no-border" : ""}`}>
        <p>
          <span className="bold">{`${category}: `}</span>
        </p>
        <img
          src={isOpen ? chevronUp : chevronDown}
          alt="chevron-down"
          onClick={() => {
            onTrackButtonClick?.(
              `${isOpen ? "collapse" : "expand"}_faq_${category
                .toLowerCase()
                .replace(/\s+/g, "_")}`,
              "your_stay_faq"
            );
            setIsOpen(!isOpen);
          }}
        />
      </div>
      {isOpen &&
        questions.map(({ question, answer }) => (
          <div key={question}>
            <p className="bold">{question}</p>
            <p>{answer}</p>
          </div>
        ))}
    </div>
  );
};

export default FaqItem;
